import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { FastCleanerModalProps } from 'reactApp/sections/QuotaLanding/FastCleaner/FastCleanerModal/FastCleanerModal.types';

export const renderFastCleanConfirmModal = (data?: FastCleanerModalProps) => {
    openPopupHelper({
        popupName: popupNames.FAST_CLEANER_CONFIRM,
        data,
        onClose: data?.onClose,
    });
};
